/**
 * Application root: the providers, in the order everything else depends on.
 *
 * Toasts sit outside the router so a message survives a navigation, and the
 * error boundary sits outermost so a crash in a provider still renders
 * something a person can act on.
 */
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ToastProvider } from './components/Toast'
import { queryClient } from './lib/queryClient'
import { createAppRouter } from './routes'

const router = createAppRouter()

export default function App() {
  return (
    <ErrorBoundary fallbackTitle="The console failed to start">
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
